/**
 * API Configuration
 * 
 * This file centralizes the backend API URL configuration.
 * The API URL can be set via the REACT_APP_API_URL environment variable.
 * 
 * Default: http://localhost:8000 (for local development)
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// SECURITY: Only expose API URL in development for debugging
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  window.__FOODIFY_API_URL__ = API_URL;
  // Check if env var was set by comparing to default
  const isDefault = API_URL === 'http://localhost:8000';
  window.__FOODIFY_DEBUG__ = {
    apiUrl: API_URL,
    isDefault: isDefault,
    envVarSet: !isDefault, // If not default, env var was likely set
    note: 'Check this in browser console to debug API URL issues'
  };
}

// SECURITY: Only log API URL in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Foodify API URL configured:', API_URL);
  if (!API_URL || API_URL === 'http://localhost:8000') {
    console.warn('⚠️ WARNING: Using default API URL (localhost). Set REACT_APP_API_URL environment variable for production!');
  }
}

/**
 * Get the full API URL for a given endpoint
 * @param {string} endpoint - The API endpoint (e.g., '/users', '/restaurants')
 * @returns {string} The full URL
 */
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const fullUrl = `${API_URL}${cleanEndpoint}`;
  
  // SECURITY: Only log API requests in development
  // Don't log in production to avoid exposing endpoints
  
  return fullUrl;
};

export default API_URL;
